"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestrictionRuleAllowedWhen = void 0;
const _1 = require("./");
const cloneModelObject_1 = require("../../../../../apis/spg/util/cloneModelObject");
/**
 * Restriction Rule: AllowedWhen
 *
 * This rule limits certain item’s availability based on if certain other items
 * have been chosen or not. For example, a burrito product blueprint comes with
 * A protein category with three options: beef, pork and lamb, and a topping
 * category with three options, lettuce, cheese and guac. It also comes with a
 * AllowedWhen restriction rule saying cheese is only allowed when pork or lamb
 * is selected. Given such a blueprint, cheese would only become an available
 * option if the customer had chosen pork or lamb. On the other hand, cheese
 * would be disabled if the customer had chosen beef.
 */
class RestrictionRuleAllowedWhen {
    constructor(data) {
        this.name = _1.TRestrictionRuleName.allowedWhen;
        if (data) {
            this.productId = data.productId;
            this.dependencies = data.dependencies;
        }
    }
    filterSensitiveData() {
        const clone = (0, cloneModelObject_1.cloneModelObject)(this);
        return clone;
    }
    serialize() {
        return {
            name: this.name,
            productId: this.productId,
            dependencies: this.dependencies
        };
    }
    static unserialize(data) {
        const newRestrictionRuleAllowedWhen = new this();
        newRestrictionRuleAllowedWhen.productId = data.productId;
        newRestrictionRuleAllowedWhen.dependencies = data.dependencies;
        return newRestrictionRuleAllowedWhen;
    }
    isValid(products, productAvailability, selectedProducts) {
        const isProductSelected = this.isProductSelected(selectedProducts);
        const isAnyDependencySelected = this.isAnyDependencySelected(selectedProducts);
        return isProductSelected ? (isAnyDependencySelected ? true : false) : true;
    }
    apply(products, productAvailability, selectedProducts) {
        const isProductSelected = this.isProductSelected(selectedProducts);
        const isAnyDependencySelected = this.isAnyDependencySelected(selectedProducts);
        if (isProductSelected && !isAnyDependencySelected) {
            this.removeFromSelection(selectedProducts);
            productAvailability.map(pa => {
                if (pa.productId === this.productId) {
                    pa.canAdd = false;
                    pa.canRemove = false;
                }
            });
        }
        if (!isProductSelected && !isAnyDependencySelected) {
            productAvailability.map(pa => {
                if (pa.productId === this.productId) {
                    pa.canAdd = false;
                }
            });
        }
    }
    removeFromSelection(selectedProducts) {
        const i = selectedProducts.findIndex(sp => sp.product.productId === this.productId);
        selectedProducts.splice(i, 1);
    }
    isProductSelected(selectedProducts) {
        return selectedProducts.some(sp => sp.product.productId === this.productId && sp.quantity > 0);
    }
    isAnyDependencySelected(selectedProducts) {
        return selectedProducts.some(sp => this.dependencies.indexOf(sp.product.productId) !== -1 &&
            sp.quantity > 0);
    }
}
exports.RestrictionRuleAllowedWhen = RestrictionRuleAllowedWhen;
//# sourceMappingURL=RestrictionRuleAllowedWhen.js.map